import { OptionalLink, OptionalLinkProps } from '@/components/OptionalLink';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { ReactNode } from 'react';
import { ListTag, Tag } from './Tag';

export type StandaloneTagProps = StandaloneComponentProps<typeof Tag> & {
  value?: ReactNode;
  link?: OptionalLinkProps;
  partOfList?: boolean;
};

export const StandaloneTag: StandaloneComponent<StandaloneTagProps> = ({ value, link, ...props }) => {
  const { partOfList = false, ...rest } = props;
  const Wrapper = partOfList ? ListTag : Tag;

  return (
    <Wrapper {...rest}>
      <OptionalLink {...link}>{value}</OptionalLink>
    </Wrapper>
  );
};
